import { IMobileCopyPaste } from '@src/slide/application/service/copy-paste/core/mobile/mobile-copy-paste.interface';
import { IPcCopyPaste } from '@src/slide/application/service/copy-paste/core/pc/pc-copy-paste.interface';
import type { IDynamicServiceConfig } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

export const pcCopyPasteManagerDynamicConfig: IDynamicServiceConfig<IPcCopyPaste> = {
    name: 'copy-paste-manager-pc',
    loadType: 'on-demand',
    async module() {
        const { PcCopyPaste } = (await import('@src/slide/application/service/copy-paste/core/pc'));
        return new PcCopyPaste();
    },
};

export const mobileCopyPasteManagerDynamicConfig: IDynamicServiceConfig<IMobileCopyPaste> = {
    name: 'copy-paste-manager-mobile',
    loadType: 'eager',
    async module() {
        const { MobileCopyPaste } = (await import('@src/slide/application/service/copy-paste/core/mobile'));
        return new MobileCopyPaste();
    },
};

type CopyPasteImageService = typeof import('@src/slide/application/service/copy-paste/core/export-image');

export const copyPasteImageServiceDynamicConfig: IDynamicServiceConfig<CopyPasteImageService> = {
    name: 'copy-paste-image',
    loadType: 'on-demand',
    async module() {
        const copyPasteImageService = await import('@src/slide/application/service/copy-paste/core/export-image');
        return copyPasteImageService;
    },
};
